export default __webpack_public_path__ + "static/media/Power Harrow.9afcc66d.png";